const enumValue = description => Object.freeze({toString: () => description});

export const PLATE = enumValue('PLATE');
export const DATE_CAPTURED = enumValue('DATE_CAPTURED');
export const CONFIDENCE = enumValue('CONFIDENCE');
export const NO_SORT = enumValue('');